import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { handleAuth0CreateAccountCallback } from '@redux/actions/auth0-callback/auth0CallbackActions';

// Components
import LoadingScreen from '@components/loading-screen';

const Auth0CallbackCreateAccount = () => {
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(handleAuth0CreateAccountCallback());
  }, []);

  return <LoadingScreen show />;
};

export default Auth0CallbackCreateAccount;
